export default {
   hasId: function(idObj) {
      return !$.isEmptyObject(idObj)
             && 'id' in idObj
             && idObj.id !== undefined;
   },
   getId: function(idObj, defaultId) {
      if(this.hasId(idObj))
      {
         return idObj.id;
      }
      return defaultId;
   },
   getIds: function (idObjs, defaultIds) {
      if(idObjs && Array.isArray(idObjs))
      {
         return idObjs
                 .filter(idObj => this.hasId(idObj))
                 .map(idObj => idObj.id);
      }
      return defaultIds;
   },
   isValidRef: function (ref) {
      return !$.isEmptyObject(ref)
             && 'id' in ref
             && this.isValidRefId(ref.id);
   },

   isValidRefId: function (id) {
      return id !== undefined
             && id > 0;
   },

   isValidRefIds: function (ids) {
      if(ids && Array.isArray(ids)) {
         return ids && ids.filter(id => this.isValidRefId(id)).length > 0
      }
      return false;
   },

   getRefId: function (ref, defaultRefId) {
      if(this.isValidRef(ref))
      {
         return ref.id;
      }
      return defaultRefId;
   },

   getRefIds: function (refs, defaultRefIds) {
      if(refs && Array.isArray(refs))
      {
         return refs
                 .filter(ref => this.isValidRefId(ref.id))
                 .map(ref => ref.id);
      }
      return defaultRefIds;
   },

   getFirstRefId: function (refs) {
      let refIds = this.getRefIds(refs);
      if(refIds && refIds.length > 0)
      {
         return refIds[0];
      }
      return null;
   },

   isValidRefValue: function (value) {
      return value !== undefined
              && value !== '';
   },

   hasRefValue: function(ref) {
      return !$.isEmptyObject(ref)
             && 'value' in ref
             && this.isValidRefValue(ref.value)
   },

   getRefValue: function (ref, defaultRefValue) {
      if(this.hasRefValue(ref))
      {
         return ref.value;
      }
      return defaultRefValue;
   },

   getRefValues: function (refs, defaultRefValues) {
      if(refs && Array.isArray(refs))
      {
         return refs
                 .filter(ref => this.isValidRefValue(ref.value))
                 .map(ref => ref.value);
      }
      return defaultRefValues;
   },

   getRefParam(ref, paramName, defaultParam)
   {
      if(this.isValidRef(ref))
      {
         if(ref.params)
         {
            return ref.params[paramName] || defaultParam;
         }
      }
      return defaultParam;
   },

   getRefName(ref, pLanguage)
   {
      if(pLanguage === 'fr') {
         return ref.names.fr || ref.name;
      }
      return ref.name;
   },

   findRefById(refs, refId, defaultRef)
   {
      let result = refs.filter(ref => ref.id === refId);
      return result ? result[0] : defaultRef;
   },

   findRefsByIds(refs, refIds)
   {
      let _refIds = Array.isArray(refIds) ? refIds : [refIds];
      return refs.filter(ref => _refIds.includes(ref.id));
   },

   findChildRefsByIds(refs, refIds)
   {
      let _refIds = Array.isArray(refIds) ? refIds : [refIds];
      return refs.reduce((accumulator, ref) => {
         let result = ref.childDataRefs.filter(childRef => _refIds.includes(childRef.id));
         accumulator.push(...result);
         return accumulator;
      }, []);
   }
}